import { useState } from 'react';
import { Checkbox } from 'antd';
import { useStore } from '../../../store/store';
import { handleTransformIndicator } from '../../common/TitleConfiguration';
import { headerIndentation, numberedTitleLevels } from '../../../utils/titles';
import { isStyleFromSection } from '../../../utils/styles';

const selector = ({ configuration }) => ({
  configuration,
});

// Chaque injection de section importe une copie de ses styles. Sur un document
// à sections récursives, cela se compte en centaines : la liste du configurateur
// devient inutilisable. On ne montre donc par défaut que les styles propres au
// document, les autres restant accessibles via la case.
export const useSectionStylesFilter = (styles) => {
  const [showSectionStyles, setShowSectionStyles] = useState(false);
  const sectionStylesCount = styles.filter(isStyleFromSection).length;
  return {
    visibleStyles: showSectionStyles
      ? styles
      : styles.filter((style) => !isStyleFromSection(style)),
    filter: sectionStylesCount === 0 ? null : (
      <Checkbox
        checked={showSectionStyles}
        onChange={(e) => setShowSectionStyles(e.target.checked)}
        style={{ margin: '0 2rem 1rem', display: 'flex' }}
      >
        Afficher les styles issus des sections ({sectionStylesCount})
      </Checkbox>
    ),
  };
};

export const ItemLabel = ({ label }) => {
  return <div style={{ marginLeft: '2%', marginTop: '2%' }}>{label}</div>;
};

// Aperçu de l'index d'un niveau : un glyphe d'exemple par niveau de la chaîne,
// du premier niveau numéroté jusqu'à celui-ci — les niveaux sans numéro
// intercalés en font partie, comme dans le document. Renvoie '' quand le niveau
// lui-même n'est pas numéroté.
export const handleTitleIndex = (title) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { configuration } = useStore(selector);
  const level = headerIndentation[title];
  if (!level) return null;
  const numberedLevels = numberedTitleLevels(configuration);
  if (!numberedLevels[level - 1]) return '';
  const firstNumbered = numberedLevels.indexOf(true);

  let index = '';
  for (let l = firstNumbered + 1; l <= level; l++) {
    index += handleTransformIndicator(configuration[`title${l}`].typeTitle);
    // Même règle que displayTitleIndex pour le séparateur après le dernier numéro.
    if (l < level || configuration.finalSeparatorTitle !== false) {
      index += configuration.separatorTitle;
    }
  }
  return index;
};
